export default __webpack_public_path__ + "static/media/google.c522c817.png";